import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

const AccordionChild = ({ children, childrenHeight, isActive, updateHeight }) => {
  const section = useRef(null);

  const [load, setLoad] = useState(false);
  const [maxHeight, setMaxHeight] = useState(false);

  useEffect(() => {
    const height = childrenHeight ? childrenHeight : section.current.scrollHeight;
    setLoad(true);
    setMaxHeight(height);
  }, [children, updateHeight]);

  return (
    <div className="accordion__children" ref={section} style={{ maxHeight: isActive && load && section.current ? maxHeight : 0 }}>
      {children}
    </div>
  );
};

AccordionChild.propTypes = {
  children: PropTypes.object,
  isActive: PropTypes.bool,
};

AccordionChild.defaultProps = {
  isActive: false,
};

export default AccordionChild;
